import { Component, EventEmitter, Input, Output, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';

import { SessionService } from '../../shared/session.service';
import { BaseComponent } from '../../../app/base.component';
import { Account, SiteConfig, User } from '../../../app/shared/models';
import { takeUntil } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent extends BaseComponent implements OnInit, AfterViewInit {
  account: Account;
  siteConfig: SiteConfig;
  sessionIsAuthorized: boolean;
  sessionIsReady: boolean;
  user: User;
  shouldAppendSurveyScript = false;
  isLandingPage: boolean;
  welcomeName: string;
  showOnboardingLink: boolean = false;

  private _isCollapsed = true;
  private isSurveyScriptAppended = false;
  private surveyPartnerId = 292;

  @Input() set isCollapsed(value: boolean) {
    this._isCollapsed = value;
    this.isCollapsedChange.emit(this._isCollapsed);
  }
  @Output() isCollapsedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  get isCollapsed(): boolean {
    return this._isCollapsed;
  }
  ngOnInit() {
    combineLatest([
      this.sessionService.account,
      this.sessionService.siteConfig,
      this.sessionService.isLandingPage,
      this.sessionService.isAuthorized(),
      this.sessionService.isReady(),
      this.sessionService.user
    ])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([account, siteConfig, isLandingPage, sessionIsAuthorized, sessionIsReady, user]) => {
        this.account = account;
        this.showOnboardingLink = account && account.hasFeature('starterseo');
        this.shouldAppendSurveyScript = this.account && this.account.partnerId === this.surveyPartnerId;
        this.siteConfig = siteConfig;
        this.isLandingPage = isLandingPage;
        this.sessionIsAuthorized = sessionIsAuthorized;
        this.sessionIsReady = sessionIsReady;
        this.user = user;
        this.cdr.detectChanges();

        this.welcomeName = user.customerUsers.every(x => x.isReportingUser) ? account?.name : user?.firstName;
      });
  }

  ngAfterViewInit() {
    if (this.shouldAppendSurveyScript) {
      this.appendSurveyScript();
    }
  }

  constructor(public sessionService: SessionService, private router: Router, private elementRef: ElementRef, private cdr: ChangeDetectorRef) {
    super();
  }

  public logoff(event: Event) {
    event.preventDefault();

    this.isCollapsed = false;
    this.router.navigateByUrl('log-out');
  }

  public clickedOutside() {
    this.isCollapsed = true;
  }

  private appendSurveyScript() {
    if (this.isSurveyScriptAppended) {
      return;
    }
    this.isSurveyScriptAppended = true;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'assets/survey.js';
    this.elementRef.nativeElement.appendChild(script);
  }
}
